import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-4 text-primary fw-bold">
        MarketMind4U – Privacy Policy
      </h1>

      <section>
        <h>1. Introduction</h>
        <p>
          Welcome to <strong>MarketMind4U</strong>. Your privacy is very
          important to us. This Privacy Policy explains how we collect, use,
          store, and protect your personal information when you visit our
          website or use our services. By using our platform, you agree to this
          Privacy Policy.
        </p>
      </section>

      <section>
        <h>2. Information We Collect</h>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, email address, contact
            number, and business details provided during registration or
            inquiries.
          </li>
          <li>
            <strong>Payment Information:</strong> Billing details, payment
            confirmation, and transaction-related data for service payments.
          </li>
          <li>
            <strong>Technical Data:</strong> IP address, browser type, device
            information, and cookies for analytics and improvement.
          </li>
        </ul>
      </section>

      <section>
        <h>3. How We Use Your Information</h>
        <p>Your information helps us to:</p>
        <ul>
          <li>Deliver and manage the services you request.</li>
          <li>Communicate updates, invoices, and marketing offers.</li>
          <li>Improve our platform and user experience.</li>
          <li>
            Maintain compliance with legal requirements and resolve disputes.
          </li>
        </ul>
      </section>

      <section>
        <h>4. Data Protection and Security</h>
        <p>
          MarketMind4U follows strict data security practices to safeguard your
          information. We use encryption, secure servers, and access control to
          prevent unauthorized access, loss, or misuse of data. However, please
          note that no online platform can guarantee 100% data security.
        </p>
      </section>

      <section>
        <h>5. Sharing of Information</h>
        <p>
          We do not sell, rent, or trade your personal information. We may share
          data only with:
        </p>
        <ul>
          <li>
            Service partners who assist in delivering our products and services.
          </li>
          <li>
            Legal authorities, when required by law or to protect our legal
            rights.
          </li>
        </ul>
      </section>

      <section>
        <h>6. Cookies and Tracking</h>
        <p>
          Our website uses cookies and similar technologies to analyze traffic,
          personalize content, and enhance your browsing experience. You can
          choose to disable cookies through your browser settings, but some
          parts of our website may not function properly without them.
        </p>
      </section>

      <section>
        <h>7. Your Rights</h>
        <p>
          You have the right to request access to your personal data, correct
          inaccuracies, or ask for deletion of your information. To do so,
          contact us at{" "}
          <strong className="text-primary">info@marketmind4u.com</strong>.
        </p>
      </section>

      

      <section>
        <h>8. Data Retention</h>
        <p>
          We retain your information only for as long as necessary to fulfill
          the purposes described in this policy or as required by law. After
          that, your data will be securely deleted.
        </p>
      </section>

      <section>
        <h>9. Changes to This Policy</h>
        <p>
          MarketMind4U reserves the right to modify this Privacy Policy at any
          time without prior notice. Updates will be posted on this page, and
          the “Last Updated” date will be revised accordingly.
        </p>
      </section>

      <section>
        <h>10. Contact Us</h>
        <p>
          For any privacy-related questions or concerns, please contact us at:{" "}
          <br />
          <strong>Email:</strong> 
             <a href="mailto:info@marketmind4u.com">     info@marketmind4u.com</a><br />          
          <strong>Phone:</strong> +91-7906576404 <br />
          <strong>Address:</strong> G07-Ground Floor-H-61,H Block , Noida Sector-63, Pincode-201309.
        </p>
      </section>

      <hr />
      <p className="text-center text-muted small mt-4">
        © {new Date().getFullYear()} MarketMind4U. All rights reserved.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
